import { post, get } from './server';

// const base = process.env.NODE_ENV === 'production' ? 'https://api-v2.xiaodingfang.com' : 'https://api-dev.yeahotel.com';
const base = 'https://api-v2.xiaodingfang.com';
// const base = 'https://api-dev.yeahotel.com';

// 授权
export const getToken = params => { return get(`${base}/app/findToken`, params); };
export const requestLogin = params => { return post(`${base}/app/signIn`, params); };
export const editPassword = params => { return post(`${base}/app/password`, params); };
export const findMe = params => { return get(`${base}/people/findMe`, params); };

export const sendCode = params => { return post(`${base}/app/sendCode`, params); };

// 酒店管理
export const addApp = params => { return post(`${base}/super/createApp`, params); };
export const editApp = params => { return post(`${base}/super/updateApp`, params); };
export const getAppList = params => { return get(`${base}/super/findAppList`, params); };
export const getClientApp = params => { return get(`${base}/super/findClientApp`, params); };
export const getAppConfig = params => { return get(`${base}/super/getAppConfig`, params); };
export const getEndPoints = params => { return get(`${base}/super/findEndPointList`, params); };
export const getEndPoint = params => { return get(`${base}/guide/findEndPoint`, params); };

// 程序管理
export const addToTemplate = params => { return post(`${base}/super/addToTemplate`, params); };
export const removeTemplate = params => { return post(`${base}/super/removeTemplate`, params); };
export const getTemplateList = params => { return get(`${base}/super/findTemplateList`, params); };
export const getTemplateDraftList = params => { return get(`${base}/super/findTemplateDraftList`, params); };
export const addMessageTemplate = params => { return post(`${base}/super/addMessageTemplate`, params); };
export const removeMessageTemplate = params => { return post(`${base}/super/removeMessageTemplate`, params); };
export const getMessageTemplateLibraryList = params => { return get(`${base}/super/findMessageTemplateLibraryList`, params); };
export const getMessageTemplateLibrary = params => { return get(`${base}/super/findMessageTemplateLibrary`, params); };
export const getMessageTemplateList = params => { return get(`${base}/super/findMessageTemplateList`, params); };
export const commitCode = params => { return post(`${base}/super/commit`, params); };
export const getQrcode = params => { return get(`${base}/super/getQrcode`, params); };
export const getCategory = params => { return get(`${base}/super/getCategory`, params); };
export const submitAudit = params => { return post(`${base}/super/submitAudit`, params); };
export const getLatestAuditStatus = params => { return get(`${base}/super/getLatestAuditStatus`, params); };
export const release = params => { return post(`${base}/super/release`, params); };
export const revertCodeRelease = params => { return post(`${base}/super/revertCodeRelease`, params); };
export const modifyDomain = params => { return post(`${base}/super/modifyDomain`, params); };
export const setWebviewDomain = params => { return post(`${base}/super/setWebviewDomain`, params); };
export const bindTester = params => { return post(`${base}/super/bindTester`, params); };
export const unbindTester = params => { return post(`${base}/super/unbindTester`, params); };

// 员工管理
export const addRole = params => { return post(`${base}/role/create`, params); };
export const editRole = params => { return post(`${base}/role/update`, params); };
export const removeRole = params => post(`${base}/role/remove`, params);
export const getRoleList = params => { return get(`${base}/role/findList`, params); };
export const getRoleAll = params => { return get(`${base}/role/findAll`, params); };
export const getAuthorityAll = params => { return get(`${base}/app/findAuthorityAll`, params); };

// 代理商管理
export const addAgent = params => post(`${base}/branch/createAgent`, params);
export const editAgent = params => post(`${base}/branch/updateAgent`, params);
export const delAgent = params => post(`${base}/branch/removeAgent`, params);
export const getAgent = params => get(`${base}/branch/findAgent`, params);
export const getAgents = params => get(`${base}/branch/findAgentList`, params);
export const getAgentAll = params => get(`${base}/branch/findAgentAll`, params);

// 日志管理
export const getLogList = params => { return get(`${base}/app/findLogList`, params); };

// 报表管理
export const getReport = params => { return get(`${base}/super/findReport`, params); };

// 反馈管理
export const getFeedbackList = params => { return get(`${base}/super/findAppCommentList`, params); };

// 添加模板消息 POST super/templateAdd
// 参数：token， appId, clientAppId, templateId, keywordIdList
export const addTemplate = (params, reject) => { return post(`${base}/super/templateAdd`, params, reject); };

// 撤回审核 POST super/undoCodeAudit
// 参数：token ,appId, clientAppId
export const undoCodeAudit = params => { return post(`${base}/super/undoCodeAudit`, params); };
// 隐私设置
export const setPrivacySetting = params => { return post(`${base}/super/setPrivacySetting`, params); };
// 查询隐私设置
export const getPrivacySetting = params => { return get(`${base}/super/getPrivacySetting`, params); };

// 获取服务器日志 GET super/findLogList
// 参数：token,appId, page, size, machine(服务器IP，选填),service(微服务名，选填)，env（模式，'DEV' || 'PRO'，选填）,level(日志等级，‘DEBUG’,'INFO','ERROR'，选填)，keyword(日志内容，选填)，startTime && endTime(时间段，'YYYY-MM-DD HH:mm:ss'，选填)
export const findSuperLogList = params => { return get(`${base}/super/findLogList`, params); };
export const findSuperLog = params => { return get(`${base}/super/findLog`, params); };

// 产品功能管理
export const createWidget = params => { return post(`${base}/super/createWidget`, params); };
export const updateWidget = params => { return post(`${base}/super/updateWidget`, params); };
export const removeWidget = params => { return post(`${base}/super/removeWidget`, params); };
export const findWidget = params => { return get(`${base}/super/findWidget`, params); };
export const findWidgetList = params => { return get(`${base}/super/findWidgetList`, params); };
export const findWidgetAll = params => { return get(`${base}/super/findWidgetAll`, params); };
export const findAppWidgetAll = params => { return get(`${base}/super/findAppWidgetAll`, params); };
export const addAppWidget = params => { return post(`${base}/super/createAppWidget`, params); };
export const editAppWidget = params => { return post(`${base}/super/updateAppWidget`, params); };
export const delAppWidget = params => { return post(`${base}/super/removeAppWidget`, params); };

// 订阅消息
export const addTemplateNew = params => { return post(`${base}/super/addTemplateNew`, params); };
export const delTemplateNew = params => { return post(`${base}/super/delTemplateNew`, params); };
export const getTemplateNew = params => { return get(`${base}/super/getTemplateNew`, params); };
export const getCategoryNew = params => { return get(`${base}/super/getCategoryNew`, params); };
export const getPubTemplateTitlesNew = params => { return get(`${base}/super/getPubTemplateTitlesNew`, params); };
export const getPubTemplateKeywordsNew = params => { return get(`${base}/super/getPubTemplateKeywordsNew`, params); };

// 申请接口
export const applyPrivacyInterface = params => { return post(`${base}/super/applyPrivacyInterface`, params); };
export const getPrivacyInterface = params => { return get(`${base}/super/getPrivacyInterface`, params); };